import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.login');
import { OnInit, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-login',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.login/view.scss */
:host {
  display: block;
  height: 100%;
}

.login-page {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 1.5rem;
}

.login-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(-45deg, #0f172a, #1e1b4b, #172554, #0c4a6e);
  background-size: 400% 400%;
  animation: bgShift 20s ease infinite;
}

@keyframes bgShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.login-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  pointer-events: none;
}

.orb-1 {
  width: 500px;
  height: 500px;
  background: rgba(59, 130, 246, 0.3);
  top: -15%;
  right: -10%;
  animation: float1 18s ease-in-out infinite;
}

.orb-2 {
  width: 400px;
  height: 400px;
  background: rgba(139, 92, 246, 0.25);
  bottom: -15%;
  left: -10%;
  animation: float2 22s ease-in-out infinite;
}

.orb-3 {
  width: 300px;
  height: 300px;
  background: rgba(6, 182, 212, 0.2);
  top: 50%;
  left: 30%;
  animation: float3 25s ease-in-out infinite;
}

.orb-4 {
  width: 250px;
  height: 250px;
  background: rgba(16, 185, 129, 0.15);
  bottom: 30%;
  right: 25%;
  animation: float4 20s ease-in-out infinite;
}

@keyframes float1 {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(40px, -60px) scale(1.1);
  }
  66% {
    transform: translate(-30px, 40px) scale(0.9);
  }
}
@keyframes float2 {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(-50px, 30px) scale(1.05);
  }
  66% {
    transform: translate(40px, -40px) scale(0.95);
  }
}
@keyframes float3 {
  0%, 100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(60px, -30px);
  }
}
@keyframes float4 {
  0%, 100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(-40px, 50px);
  }
}
.login-grid {
  position: absolute;
  inset: 0;
  opacity: 0.04;
  background-image: linear-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, transparent 1px);
  background-size: 60px 60px;
  pointer-events: none;
}

.login-glow {
  position: absolute;
  bottom: -40%;
  left: 50%;
  transform: translateX(-50%);
  width: 800px;
  height: 400px;
  background: radial-gradient(ellipse, rgba(99, 102, 241, 0.15) 0%, transparent 70%);
  pointer-events: none;
}

.login-card {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 420px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(40px) saturate(180%);
  -webkit-backdrop-filter: blur(40px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 1.5rem;
  padding: 2.5rem;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.8);
  animation: cardEntrance 0.8s cubic-bezier(0.16, 1, 0.3, 1) both;
}

@keyframes cardEntrance {
  from {
    opacity: 0;
    transform: translateY(40px) scale(0.96);
    filter: blur(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
}
.login-logo {
  width: 56px;
  height: 56px;
  border-radius: 1rem;
  background: linear-gradient(135deg, #3b82f6, #6366f1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 22px;
  box-shadow: 0 8px 30px rgba(99, 102, 241, 0.4);
  animation: logoPulse 3s ease-in-out infinite;
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  cursor: default;
}
.login-logo:hover {
  transform: rotate(10deg) scale(1.05);
}

@keyframes logoPulse {
  0%, 100% {
    box-shadow: 0 8px 30px rgba(99, 102, 241, 0.4);
  }
  50% {
    box-shadow: 0 8px 50px rgba(99, 102, 241, 0.65);
  }
}
.login-divider {
  width: 3rem;
  height: 3px;
  border-radius: 999px;
  background: linear-gradient(90deg, #3b82f6, #8b5cf6);
  margin: 0 auto;
  opacity: 0.6;
}

.login-form-wrap {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.login-form-wrap.form-exit {
  opacity: 0;
  transform: translateY(-8px);
}

.form-animate {
  animation: formAppear 0.45s cubic-bezier(0.16, 1, 0.3, 1) both;
  animation-delay: 0.05s;
}

@keyframes formAppear {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.login-footer {
  position: absolute;
  bottom: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  text-align: center;
  color: rgba(255, 255, 255, 0.3);
  font-size: 0.75rem;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

@media (max-width: 640px) {
  .login-card {
    padding: 1.75rem;
    border-radius: 1.25rem;
    max-width: 100%;
  }
  .login-page {
    padding: 1rem;
  }
  .login-orb {
    opacity: 0.5;
  }
  .login-footer {
    position: relative;
    bottom: auto;
    left: auto;
    transform: none;
    margin-top: 2rem;
  }
}`],
})
export class PageLoginComponent implements OnInit {
    public mode: string = 'login';
    public isTransitioning: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() {
        await this.service.auth.check();
        this.service.auth.allow(false, '/main');
        await this.service.loading.hide();
        this.ref.detectChanges();
    }

    public async switchMode(newMode: string) {
        if (this.mode === newMode) return;
        this.isTransitioning = true;
        this.ref.detectChanges();
        await new Promise(resolve => setTimeout(resolve, 200));
        this.mode = newMode;
        this.isTransitioning = false;
        this.ref.detectChanges();
    }
}

export default PageLoginComponent;